import React from 'react'
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    BooleanField,
    NumberField,
} from 'react-admin'


export const SistemaElectricoList = props => (
    <List {...props} exporter={false} >
        <Datagrid rowClick="show">
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="subsystem_name" />
            <TextField source="subsystem_code" />
            <BooleanField source="active" />
            <ReferenceField source="sistema_interconectado_id" reference="sistemas-interconectados">
                <TextField source="name" />
            </ReferenceField>
        </Datagrid>
    </List>
);
